import { AttachmentItemHolder } from '@nile/banyan/src/Components/Editors/RTEditor';
import {
  AppContext,
  BackgroundIcon,
  DateTimeFormatter,
  generateString,
  getDownloadURL,
  ALL_MODULES,
  AttachmentPreviewer
} from '@nile/components';
import envConfig from '@nile/home/src/Config/env';
import { Receiver, Sender } from '@nile/mangifera/src/Pebbles/chat';
import { Avatar, TextStyle } from '@superops/ui-design-system';
import dompurify from 'dompurify';
import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import styled from 'styled-components';
import AttachmentHolder from '@nile/rmm/src/modules/common/components/sub-pages/attachment-holder';
import { SVGIcon } from '@superops/super-icons';
import { dompurifier } from '@nile/components/src/Utils/helpers';

const StyledNote = styled.div`
  background: ${(props) =>
    props.user ? '#e5fdff;' : 'var(--sops-coversation-bubble-bg)'};
  border-radius: 20px 20px;
  width: 80%;
  margin-left: 12px;
  padding: 10px 15px 15px 15px;
  opacity: 1;
  transition: opacity 200ms linear;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.102874);
  .message-content {
    margin-top: 10px;
  }
  .action > div:first-child {
    visibility: hidden;
  }

  &:hover {
    .action > div:first-child {
      visibility: visible;
      cursor: pointer;
    }
  }
  .ap {
    background-image: url(${envConfig.imageRoot}emojis.webp);
  }
  .hover-hand {
    cursor: zoom-in;
  }
  .mw100{
    max-width: 100%;
  }

/* The Modal (background) */
.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 10; /* Sit on top */
  // padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (image) */
.modal-content {
  margin: auto;
  display: block;
  // width: 100%;
  max-width: 90vw;
}

@-webkit-keyframes zoom {
  from {-webkit-transform:scale(0)}
  to {-webkit-transform:scale(1)}
}

@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}

/* The Close Button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
`;

const ItemHolders = styled.div`
  gap: 10px;
  div {
    &:first-child {
      margin-left: 0;
    }
  }
`;

const AttachmentsContainer = styled(AttachmentItemHolder)`
  margin-right: 10px;
  padding: 0 1rem;
  &:hover {
    cursor: default;
  }
`;

function ConversationBubble(props) {
  const { message } = props;
  const appContext = useContext(AppContext);
  const [randomId, setRandomId] = useState(generateString(5) || 'abcde');
  const { user, company } = appContext;
  const [showAttachmentPreview, setShowAttachmentPreview] = useState({
    show: false,
    index: 0
  });
  const handleEscPress = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (e?.keyCode === 27 || e?.which === 27 || e?.key === 'Escape') {
      if (
        window.getComputedStyle(document.querySelector(`.modal-inline-images`))
          .display === 'flex'
      ) {
        document.querySelector(`.modal-inline-images`).style.display = 'none';
      }
      window.removeEventListener('keyup', handleEscPress);
    }
  };

  const imageDownloader = (e) => {
    // window.open(e.target.currentSrc, '_blank').focus();
    const modal = document.querySelector(`.modal-inline-images`);

    const modalImg = document.querySelector(`.modal-content-inline-images`);

    modal.style.display = 'flex';
    modalImg.src = e.target.currentSrc;
    window.addEventListener('keyup', handleEscPress);
  };

  useEffect(() => {
    if (
      document.querySelector(`.${randomId}`)?.querySelectorAll('img')?.length
    ) {
      document
        ?.querySelector(`.${randomId}`)
        ?.querySelectorAll('img')
        ?.forEach((img) => {
          img.classList.add('hover-hand', 'mw100');
          img.addEventListener('click', imageDownloader);
        });
      return () => {
        document
          ?.querySelector(`.${randomId}`)
          ?.querySelectorAll('img')
          ?.forEach((img) => {
            img.classList.remove('hover-hand');
            img.removeEventListener('click', imageDownloader);
          });
      };
    }
  }, []);

  const Tags = {
    sender: Sender,
    receiver: Receiver
  };
  const userType =
    message?.user?.userId === user?.userId ? 'sender' : 'receiver';
  const Tag = Tags[userType];
  let [formatterAttachment, setFormatterAttachment] = useState([]);

  /**
   * @description
   * Renders the attachment name and on clicking downloads the attachment
   * @param {object}
   * attachment object
   * @return
   * attachment element
   */
  const getAttachmentURL = (item) => {
    const module = ALL_MODULES.projectConversationAttachment;

    const details = {
      fileName: item?.fileName,
      conversationId: message?.data?.conversationId,
      projectId: message?.project?.projectId
    };

    const url = getDownloadURL({ module, details });
    return url;
  };

  /**
   * @description
   * Closing attachment previewer
   */
  const closePreviwer = () => {
    setShowAttachmentPreview({
      ...showAttachmentPreview,
      show: false
    });
  };
  /**
   *
   * Formatting attachment array for attachment previewer
   * @param {array} attachments
   * @public
   */

  function formatAttachmentForPreview(attachments, cb) {
    formatterAttachment = attachments.map((item) => {
      if (item)
        return {
          name: item.fileName,
          url: getAttachmentURL(item),
          type: item.fileName.substr(
            item.fileName.lastIndexOf('.') + 1,
            item.fileName.length
          )
        };
    });
    setFormatterAttachment(formatterAttachment);
    cb();
  }

  /**
   * @description
   * opening attachment previewer, if selected from a specific index then opening from the selected index.
   * @param {object} attachment
   * @param {number} index
   */

  function openAttachmentPreview(index, attachments, item) {
    if (attachments) {
      formatAttachmentForPreview(attachments, () => {
        setShowAttachmentPreview({
          ...showAttachmentPreview,
          show: true,
          index
        });
      });
    }
  }

  return (
    <Tag className="fx bubbleContainer">
      <div className="avatar">
        <Avatar
          size="small"
          initials={`${message?.user?.firstName?.[0]}${
            message?.user?.lastName?.[0] ? message?.user?.lastName?.[0] : ''
          }`}
          source={
            message.authorId === 'system'
              ? `${envConfig.imageRoot}svg/notification.svg`
              : ''
          }
        />
      </div>
      <SwitchTransition>
        <CSSTransition
          key={message?.id}
          timeout={200}
          in
          appear
          classNames="bubbles"
          unmountOnExit
        >
          <StyledNote
            className="bubble"
            user={message.user && userType === 'sender'}
          >
            <div className="fx">
              <div className="fx2 fx actr f-12">
                {userType === 'sender' ? (
                  <div className="mr8">
                    <SVGIcon name="Reply" size="sm" color="#323232" />
                  </div>
                ) : (
                  <div className="mr8">
                    <SVGIcon
                      name="OnboardingNotificationTemplate"
                      size="sm"
                      color="#323232"
                    />
                  </div>
                )}
                <TextStyle variation="subdued f-12">
                  <FormattedMessage id="project.details.convoBubble.postedby" />{' '}
                  &nbsp;
                  <TextStyle variation="strong">
                    {`${message?.user?.firstName} ${message?.user?.lastName}`}
                  </TextStyle>
                </TextStyle>
              </div>
              <div
                className="fx2 fx jend f-12"
                title={
                  <DateTimeFormatter type="dateTime" date={message?.time} />
                }
                // title={dayjs(message?.time).format(
                //   `${company?.dateFormat ||
                //     'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                // )}
              >
                <TextStyle variation="subdued">
                  <DateTimeFormatter type="dateTime" date={message?.time} />
                  {/* {dayjs(message?.time).format(
                    `${company?.dateFormat ||
                      'MMM DD YYYY'}, ${company?.timeFormat || 'hh:mm A'}`
                  )} */}
                </TextStyle>
              </div>
            </div>
            <p
              className={`mt10 ${randomId}`}
              dangerouslySetInnerHTML={{
                __html: dompurifier(message?.message)
              }}
            />
            <ItemHolders className="flex wrap mt-10">
              {message?.data?.attachments?.map((item, index) => {
                return (
                  <AttachmentsContainer>
                    <AttachmentHolder
                      onClick={() =>
                        openAttachmentPreview(
                          index,
                          message?.data?.attachments,
                          item
                        )
                      }
                      fileName={item?.fileName || ''}
                    />
                  </AttachmentsContainer>
                );
              })}
            </ItemHolders>
          </StyledNote>
        </CSSTransition>
      </SwitchTransition>
      {showAttachmentPreview.show && (
        <AttachmentPreviewer
          showPreviewer={showAttachmentPreview.show}
          closePreviwer={closePreviwer}
          list={formatterAttachment}
          selectedIndex={showAttachmentPreview.index}
        />
      )}
    </Tag>
  );
}

export default ConversationBubble;
